import { isNil } from 'ramda'
import {
  EVENT_STATUS_NORMAL,
  EVENT_STATUS_UPCOMING,
  EVENT_STATUS_HAPPENING,
  EVENT_STATUS_CANCELED,
  EVENT_STATUS_ENDED,
} from 'app/constants/messages'
import { TYPE_GENERAL, TYPE_EVENT, TYPE_POLL } from 'app/constants/messageType'
import { CHANNEL_CALL } from 'app/constants/channel'
import {
  SENT,
  DRAFT,
  SCHEDULED,
  UNSENT,
  POLL_OPEN,
} from 'app/constants/messageDetail'

export const checkEvent = (type, status, eventStatus, isDescheduled) => {
  if (isNil(eventStatus)) return false
  const statusAvaliable = [
    EVENT_STATUS_NORMAL,
    EVENT_STATUS_UPCOMING,
    EVENT_STATUS_HAPPENING,
  ]
  return (
    type === TYPE_EVENT &&
    status === SENT &&
    statusAvaliable.includes(eventStatus) &&
    isDescheduled
  )
}
export const checkDraft = (status) => {
  return status === DRAFT
}
export const checkViewIn = (status) => {
  return status !== DRAFT
}
export const checkUnsend = (
  type,
  status,
  channels = [],
  eventStatus = EVENT_STATUS_NORMAL,
) => {
  const isAutomatedCall =
    channels.length === 1 && channels.includes(CHANNEL_CALL)
  const isEventUnsend = [EVENT_STATUS_CANCELED, EVENT_STATUS_ENDED].includes(
    eventStatus,
  )
  const isType =
    [TYPE_GENERAL, TYPE_POLL].includes(eventStatus) ||
    (type === TYPE_EVENT && isEventUnsend)

  return isType && status === SENT && !isAutomatedCall
}
export const checkPublicLink = (publicLink, status) => {
  return !isNil(publicLink) && status !== SCHEDULED && status !== DRAFT
}
export const checkMetrics = (isDisabled, status, percentage) => {
  const isStatus = [SENT, UNSENT].includes(status)
  return !isDisabled && percentage > 0 && isStatus
}
export const checkPoll = (poll) => {
  return !isNil(poll) && poll.status === POLL_OPEN
}
